module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4xzF0"))).then(() => parcelRequire('1iHdE'));